module.exports = __webpack_public_path__ + "img/calculator.7ae6e91e.svg";